import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getTopListBokningByAfid,setofUpdatedashboardBokaTV} from 'actions'
import {isEmpty,isNull} from 'lodash'
import { withStyles } from '@material-ui/styles';
import compose from 'recompose/compose';
import Icon from '../../img/crown.svg';
import {ReactComponent as IconDev} from '../../img/crown.svg';
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import moment from 'moment';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';
const styles = theme => ({
    "@keyframes fadeIn": {
        "0%": {
          opacity: 0.4,
          transform: "scale(1,1)      translateY(0)"
        },
        "10%": {
          opacity: 0.6,
          transform: "scale(1,1)    translateY(0)"
        },
        "30%": {
          opacity: .8,
          transform: "scale(1,1)    translateY(0);"
        },
        "50%": {
          opacity: .8,
          transform: "scale(1,1)  translateY(0)"
        },
        "57%": {
          opacity: 1,
          transform: "scale(1,1)      translateY(0)"
        },
        "64%": {
          opacity: 1,
          transform: "scale(1,1)      translateY(0)"
        },
        "100%": {
          opacity:  1,
          transform: "scale(1,1)      translateY(0)"
        }
      },
      selector: {
        animation: "$fadeIn 2s cubic-bezier(0.280, 0.840, 0.420, 1) infinite"
      }
  });

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY} = accountsData
    const { TopListBokning,DashboardBokaFilterOption} = DashBoard;
    return {
        authUser,TopListBokning,DashboardBokaFilterOption,updatedashboardBokaTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getTopListBokningByAfid: (Afid,userid,FilterOption) => dispatch(getTopListBokningByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    };
}
const ColorCode=[
    '#DAA520',
    '#C0C0C0',
    '#b08d57'
]
const ShadowCode=[

    '0px 0px 15px #DAA520',
    '0px 0px 9px #C0C0C0',
    '0px 0px 9px #b08d57'
]
const DefaultValue = [
    {
        FirstName:"No.1",
        total:0,
    },
    {
        FirstName:"No.2",
        total:0,
    },
    {
        FirstName:"No.3",
        total:0,
    },
]
const DefaultValue1 = [
    {
        FirstName:"No.2",
        total:0,
    },
    {
        FirstName:"No.3",
        total:0,
    },
]
const DefaultValue2 = [
    {
        FirstName:"No.3",
        total:0,
    },
]
class ExtraLargeTopSellers extends Component {
    state={
        TopListBokning:[],
        StartJumping:false,
        DashboardBokaFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    intervalID2 = null
    intervalID1 = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getTopListBokningByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })
        this.intervalID2 = setInterval(
            ()=>{
                if(this.state.StartJumping === true){
                    this.setState({
                        StartJumping:false
                    })
                }
            },
            3000
        );
        this.intervalID1 = setInterval(
            ()=>{
                if(this.state.StartJumping === false){
                    if(this.state.TopListBokning !== this.props.TopListBokning){
                        this.setState({
                            StartJumping:true,
                            TopListBokning:this.props.TopListBokning
                        })
                    }
                }
            },
            3000
        )           
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getTopListBokningByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        clearInterval(this.intervalID1);
        clearInterval(this.intervalID2);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            this.props.getTopListBokningByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
            this.props.setofUpdatedashboardBokaTV()
        }
        if(this.props.DashboardBokaFilterOption !== this.state.DashboardBokaFilterOption && !isEmpty(this.props.DashboardBokaFilterOption))
           {
            this.setState({done:false})   
               this.props.getTopListBokningByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                DashboardBokaFilterOption:this.props.DashboardBokaFilterOption 
               }) 
           }
        }
    render() {
        return (
            <div style={{ color: 'white' }}>
            <div className="text-center" style={{ marginBottom: this.props.isFrom === 1 ? '10px' : '16px' }}>
                <h2 style={{ paddingTop: '12px', margin: '0',fontSize: this.props.isFrom === 1 ? '20px' : '24px' }}><b><IntlMessages id="DashBoard.Meeting.Per.Emp"/></b></h2>
                    <p style={{ fontSize: this.props.isFrom === 1 ? 14 : '18px', textTransform: "capitalize" }}>{format(new Date(), 'MMMM', { locale: sv })}</p>
                    {/* <p style={{ fontSize: this.props.isFrom === 1 ? 14 : '18px' }}><IntlMessages id="Month.Current"/></p> */}
            </div>
            <div className="d-flex row">
                {
                    this.state.done === false?  
                    <>
                    <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                        <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                        <div className="text-center" >
                            <Skeleton variant="circle" width={150} height={150} />
                        </div>                    
                        </div>
                        <div>
                        <p className="d-flex justify-content-center"
                        style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                        >
                        <Skeleton variant="rectangular" width={100} height={30} />
                        </p>
                            <p className="d-flex justify-content-center" 
                            style={{fontSize:20, marginTop:'-4px'}}>
                            <Skeleton variant="rectangular" width={100} height={20} />
                            </p>
                        </div>
                    </div>
                    <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                        <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                        <div className="text-center" >
                            <Skeleton variant="circle" width={150} height={150} />
                        </div>                    
                        </div>
                        <div>
                        <p className="d-flex justify-content-center"
                        style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                        >
                        <Skeleton variant="rectangular" width={100} height={30} />
                        </p>
                            <p className="d-flex justify-content-center" 
                            style={{fontSize:20, marginTop:'-4px'}}>
                            <Skeleton variant="rectangular" width={100} height={20} />
                            </p>
                        </div>
                    </div>
                    <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                        <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                        <div className="text-center" >
                            <Skeleton variant="circle" width={150} height={150} />
                        </div>                    
                        </div>
                        <div>
                        <p className="d-flex justify-content-center"
                        style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                        >
                        <Skeleton variant="rectangular" width={100} height={30} />
                        </p>
                            <p className="d-flex justify-content-center" 
                            style={{fontSize:20, marginTop:'-4px'}}>
                            <Skeleton variant="rectangular" width={100} height={20} />
                            </p>
                        </div>
                    </div>
                    </>:
                isEmpty(this.state.TopListBokning)?
                DefaultValue.map((object,index) =>
                <div className="col-4" style={{ marginTop:'1rem' }}>
                    <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                        <div className="text-center" 
                        style={{ 
                            position: 'relative',
                            backgroundColor: 'transparent', 
                            width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                            height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                            border: `6px solid ${ColorCode[index]}`, 
                            borderRadius: '100px',
                            // boxShadow:`${ShadowCode[index]}`,
                            boxShadow:`5px 5px 8px #00000040`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                            }}>
                            <p style={{ fontSize: 30,  marginTop: this.props.circleHeight === 150 ? '3rem' : '2rem' }}>
                            {/* <p style={{ fontSize: 65, marginTop:'1.5rem' }}> */}
                            {`?`}
                            </p>
                                {
                                    index === 0 ?
                                        <>
                                        {
                                            process.env.NODE_ENV === 'development' ?
                                            <IconDev style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top: this.props.circleHeight === 150 ? '-25%' : '-28%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </IconDev>
                                            :
                                            <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top: this.props.circleHeight === 150 ? '-25%' : '-28%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </Icon>
                                        }
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top: this.props.circleHeight === 150 ?'-20%' : '-23%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                        </>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                }
                                {
                                    index === 2 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                        </div>
                    </div>
                    <div>
                      <p className="d-flex justify-content-center" 
                        style={{marginTop:'5px',  marginBottom:'0', fontSize:"1.7rem"}}>
                        {this.formatNumber(parseInt(object.total))}
                        </p>
                        <p className="d-flex justify-content-center" 
                        style={{fontSize: 20, marginTop:'-4px'}}>
                        {`${object.FirstName}`}    
                        </p>
                    </div>
                </div>
            )
            : 
                this.state.TopListBokning.map((object,index) =>
                    <div className="col-4" style={{ marginTop:'1rem' }}>
                        <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                            <div className="text-center" 
                            style={{ 
                                position: 'relative',
                                backgroundColor: isNull(object.ProfilePicUrl) ? 'transparent' : '', 
                                width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                border: `6px solid ${ColorCode[index]}`, 
                                // boxShadow:`${ShadowCode[index]}`,
                                boxShadow:`5px 5px 8px #00000040`,
                                borderRadius: '100px',
                                // boxShadow:`rgb(11, 11, 11) 0px 0px 30px`,
                                backgroundImage: 'url('+object.ProfilePicUrl+')',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                                }}>
                                <p style={{ fontSize: 50, marginTop: this.props.circleHeight === 150 ? '2rem' : '1rem' }}>
                                {
                                    isNull(object.ProfilePicUrl) ?(
                                        `${object.FirstName[0]}${isEmpty(object.LastName)?"":object.LastName[0]}`):''
                                    }
                                </p>
                                {
                                    index === 0 ?
                                        <>
                                        {
                                            process.env.NODE_ENV === 'development' ?
                                            <IconDev style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top: this.props.circleHeight === 150 ? '-25%' : '-28%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </IconDev>
                                            :
                                            <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top: this.props.circleHeight === 150 ? '-25%' : '-28%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </Icon>
                                        }
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top: this.props.circleHeight === 150 ?'-20%' : '-23%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                        </>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                }
                                {
                                    index === 2 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                            </div>
                        </div>
                        <div>
                          {
                            parseInt(this.props.Flags.DashboardBokaFormat) === 0  ?   
                            <p className="d-flex justify-content-center" 
                            style={{marginTop:'5px',  marginBottom:'0', fontSize:"1.7rem"}}>
                            {this.formatNumber(parseInt(object.total))}
                            </p>
                            : 
                            <p className="d-flex justify-content-center" 
                            style={{marginTop:'5px',  marginBottom:'0', fontSize:"1.7rem"}}>
                            {parseInt((object.total/object.Budget)*100)}%
                            </p>
                          }
                          
                          <p className="d-flex justify-content-center" 
                        style={{fontSize: 20, marginTop:'-4px'}}>
                              {`${object.FirstName} ${isEmpty(object.LastName)?"":object.LastName}`}    
                            </p>
                        </div>
                    </div>
                )}
                 {
                    isEmpty(this.state.TopListBokning)?"":
                   (this.state.TopListBokning.length === 1)?
                   DefaultValue1.map((object,index) =>
                   <div className="col-4" style={{ marginTop:'1rem' }}>
                       <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                           <div className="text-center" 
                           style={{ 
                            backgroundColor: 'transparent', 
                            position: 'relative',
                            width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                            height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                            border: `6px solid ${ColorCode[index+1]}`, 
                            borderRadius: '100px',
                            // boxShadow:`${ShadowCode[index+1]}`,
                            boxShadow:`5px 5px 8px #00000040`,
                            // boxShadow:`rgb(11, 11, 11) 0px 0px 30px`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                               }}>
                               <p style={{ fontSize: 30, marginTop: this.props.circleHeight === 150 ? '3rem' : '2rem' }}>
                               {`?`}
                               </p>
                               {/* {
                                    index === 0 ?
                                        <>
                                        <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                        </Icon>
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top:'-15%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                        </>
                                    :   ''
                                } */}
                                {
                                    index === 0 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                           </div>
                       </div>
                       <div>
                       <p className="d-flex justify-content-center" 
                        style={{marginTop:'5px',  marginBottom:'0', fontSize:"1.7rem"}}>
                             {this.formatNumber(parseInt(object.total))}
                           </p>
                           <p className="d-flex justify-content-center" 
                        style={{fontSize: 20, marginTop:'-4px'}}>
                           {`${object.FirstName}`}    
                           </p>
                       </div>
                   </div>
               ):
               (this.state.TopListBokning.length === 2)?
               DefaultValue2.map((object,index) =>
               <div className={`col-4`} style={{ marginTop:'1rem' }}>
                   <div className={`d-flex justify-content-center ${this.state.StartJumping?this.props.classes.selector:""}`}>
                       <div className="text-center" 
                       style={{ 
                           backgroundColor: 'trasparent', 
                           position: 'relative',
                           width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                           height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                           border: `6px solid ${ColorCode[index+2]}`, 
                           borderRadius: '100px',
                        //    boxShadow:`rgb(11, 11, 11) 0px 0px 30px`,
                        //    boxShadow:`${ShadowCode[index+2]}`,
                           boxShadow:`5px 5px 8px #00000040`,
                           backgroundSize: 'cover',
                           backgroundPosition: 'center'
                           }}>
                           <p style={{ fontSize: 30, marginTop: this.props.circleHeight === 150 ? '3rem' : '2rem' }}>
                           {`?`}
                           </p>
                                {/* {
                                    index === 0 ?
                                        <>
                                        <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '35px', width: 'auto', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                        </Icon>
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top:'-15%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                        </>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top:'-15%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                } */}
                                {
                                    index === 0 ?
                                        <div style={{ height: 30, width: 30, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top: this.props.circleHeight === 150 ? '-15%' : '-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                       </div>
                   </div>
                   <div>
                   <p className="d-flex justify-content-center" 
                        style={{marginTop:'5px',  marginBottom:'0', fontSize:"1.7rem"}}>
                        {this.formatNumber(parseInt(object.total))}
                       </p>
                       <p className="d-flex justify-content-center" 
                        style={{fontSize: 20, marginTop:'-4px'}}>
                       {`${object.FirstName}`}    
                       </p>
                   </div>
               </div>
):""
                   
                }
            </div>
        </div>
        );
    }
}

export default compose(
    connect(
        mapStateToProps,mapDispatchToProps
    ),
    withStyles(styles)
    )(ExtraLargeTopSellers);